/**
 * Helper de papel do portal — usado pelo router (W1) para redirecionar por
 * role após o login: role 'client' vive em /portal e nunca vê o app staff.
 */
export function isClientRole(role: string | undefined): boolean {
  return role === 'client';
}
